import { createAction } from '@reduxjs/toolkit';
import {
  CLEAR_INTERCOM_USERS,
  DELETE_INTERCOM_USER,
  DELETE_INTERCOM_USER_FROM_CACHE,
  GET_GRATA_INTERCOM_USER,
  GET_INTERCOM_UNIT_PINS,
  PUSH_RESIDENTS_TO_INTERCOM,
  SEARCH_INTERCOM_USERS,
  UPDATE_INTERCOM_USER,
  UPDATE_INTERCOM_USERS_CACHE
} from '../constants';

export const getIntercomUnitPins = createAction(GET_INTERCOM_UNIT_PINS);
export const getGrataIntercomUser = createAction(GET_GRATA_INTERCOM_USER);
export const updateIntercomUser = createAction(UPDATE_INTERCOM_USER);
export const deleteIntercomUser = createAction(DELETE_INTERCOM_USER);
export const searchIntercomUsers = createAction(SEARCH_INTERCOM_USERS);
export const updateIntercomUserCache = createAction(UPDATE_INTERCOM_USERS_CACHE);
export const deleteIntercomUserFromCache = createAction(DELETE_INTERCOM_USER_FROM_CACHE);
export const clearIntercoms = createAction(CLEAR_INTERCOM_USERS);
export const pushResidentsToIntercom = createAction(PUSH_RESIDENTS_TO_INTERCOM);

export default {
  getIntercomUnitPins,
  updateIntercomUser,
  deleteIntercomUser,
  getGrataIntercomUser,
  searchIntercomUsers,
  updateIntercomUserCache,
  deleteIntercomUserFromCache,
  clearIntercoms,
  pushResidentsToIntercom
};
